




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { solutionListInstance } from '@/model/SolutionListClass';

@Component({
  filters: {
    formatCategoryId(categoryId: string) {
      const category = solutionListInstance.categorys.find((categoryInfo) => categoryInfo.id === categoryId);
      if (category) {
        return category.name;
      } else {
        return categoryId;
      }
    },
  },
})
export default class QuotationListTable extends Vue {
  @Prop({required: true}) private quotations!: ISolution.IClause[];
}
